/**
 * ERP Financial API client for segments.
 * @see https://erp.fms.ogintegration.us/docs/api/segments#get-all-segments
 */

import { baseErpRequest } from './erpRequest';

export type ErpSegmentField = {
  fieldName: string;
  fieldType: 'DROPDOWN' | 'TEXTBOX' | 'RADIOBUTTON';
  active: boolean;
  required: boolean;
  id?: number;
  segmentId?: number;
  fieldOptions?: string;
};

export type ErpSegment = {
  id: number;
  displayName: string;
  dataFormat: 'ALPHANUMERIC' | 'NUMERIC';
  separator: '-' | '_' | '/' | '.';
  maxLength: number;
  shortLabel: string;
  padLeadingZero: boolean;
  specialCharAllowed: boolean;
  active: boolean;
  type: string;
  order: number;
  custom: boolean;
  mandatoryForCoa: boolean;
  segmentMetadataFields: ErpSegmentField[];
  defaultCode?: string;
  customFields?: ErpSegmentField[];
  totalSegmentCode?: number;
  defaultCodeId?: number;
  regex?: string;
};

export type ErpSegmentsResponse = {
  message: string;
  data: ErpSegment[];
  statusCode: number;
  errors?: { message: string; code: string }[] | null;
};

export const getErpSegments = async (
  clientOptions: RequestInit = {},
  hostUrl?: string
): Promise<ErpSegmentsResponse> => {
  return (await baseErpRequest('/segments', clientOptions, hostUrl).get().json()) as ErpSegmentsResponse;
};
